<template>
  <div class="instrument_edit">
    <!-- <span>{{$route.params.id}}</span> -->
    <div class="search-line">
        <div class="left">
            <!-- 新建 编辑 器械 -->
            <h3>{{`${$route.params.id === '0' ? `新建` : `编辑`}器械`}}</h3>
        </div>
        <div class="right">
            <!-- 返回 -->
            <el-button type="primary" plain size="mini" @click.prevent="back"><i class="el-icon-back"></i>返回</el-button>
        </div>
    </div>
    <div class="instrument_center mt10">
        <el-tabs v-model="activeName" >
            <!-- 基本信息 -->
            <el-tab-pane :label="`基本信息`" name="first">
                <el-form :model="instrumentForm" :rules="rules" ref="instrumentForm" label-width="100px">
                    <div class="divBorder">
                        <el-row>
                            <el-col :span="6">
                                <!-- 器械归属 -->
                                <el-form-item :label="`归属`" prop="" >
                                    <!-- 请选择器械归属 -->
                                    <el-select class="input250" v-model="instrumentForm.group" clearable filterable :placeholder="`请选择`">
                                        <el-option
                                            v-for="item in sortgroups"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 全名称 -->
                                <el-form-item :label="`全名称`" prop="name">
                                    <!-- 请输入器械名称 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 名称 -->
                                <el-form-item :label="`名称`" prop="standard_name">
                                    <!-- 请输入标准名称 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.standard_name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 类型 -->
                                <el-form-item :label="`类型`" prop="">
                                    <!-- 请选择器械类型 -->
                                    <el-select class="input250" v-model="instrumentForm.instrument_type" clearable filterable :placeholder="`请选择`">
                                        <el-option
                                            v-for="item in sorttypes"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 拼音 -->
                                <el-form-item :label="`拼音`" prop="">
                                    <!-- 请输入内容 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.abc_code"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 品牌 -->
                                <el-form-item :label="`品牌`" prop="">
                                    <!-- 请输入品牌 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.brand"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 编码 -->
                                <el-form-item :label="`编码`" prop="">
                                    <!-- 请输入编码 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.code"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 单价 -->
                                <el-form-item :label="`单价`" prop="">
                                    <!-- 请输入单价 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.cost"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 备注 -->
                                <el-form-item :label="`备注`" prop="">
                                    <!-- 请输入备注 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.remark"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <!-- 使用次数 -->
                                <el-form-item :label="`可使用次数`" prop="">
                                    <el-input-number class="input250" v-model="instrumentForm.use_limit" :min="0" label="描述文字"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- 器械重量 -->
                                <el-form-item :label="`重量`" prop="">
                                    <!-- 请输入重量 -->
                                    <el-input class="input250" :placeholder="`请输入`" v-model="instrumentForm.weight">
                                        <!-- 克 -->
                                        <template slot="append">克</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                        <el-row>
                            <el-col :span="24">
                                <!-- 规格型号 -->
                                <el-form-item :label="`规格型号`" prop="" >
                                    <!-- 请输入规格型号 -->
                                    <el-input :placeholder="`请输入`" class="input200" v-model="instrumentForm.specification" v-show="!pageId ==0"></el-input>
                                    <div></div>
                                    <el-tag
                                        class="mr10"
                                        :key="tag"
                                        v-for="tag in dynamicTags"
                                        closable
                                        :disable-transitions="false"
                                        @close="handleClose(tag)">
                                        {{tag}}
                                    </el-tag>
                                    <el-input
                                        class="input-new-tag input200"
                                        v-if="inputVisible"
                                        v-model="instrumentForm.specification"
                                        ref="saveTagInput"
                                        size="small"
                                        @keyup.enter.native="handleInputConfirm"
                                        @blur="handleInputConfirm"
                                        >
                                    </el-input>
                                    <!-- 输入完成按Enter键添加 -->
                                    <el-tooltip v-show="pageId ==0" v-else :content="`输入完成按Enter键添加`" placement="top-start">
                                        <!-- 添加规格型号 -->
                                        <el-button class="button-new-tag" type="primary" size="small" @click="showInput">+ 添加</el-button>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="divBorder mt10">
                        <el-row>
                            <!-- 上传照片 -->
                            <el-form-item :label="`照片`" prop="">
                                <!-- 上传照片 -->
                                <el-button class="input150" icon="el-icon-camera" size="mini" type="primary" @click="uploadAvatar()">上传</el-button>
                            </el-form-item>
                        </el-row>
                        <div class="upload-photo">
                            <li v-for="(item,index) in images" :key="index" style="width: 100px; height:100px; margin:0 20px 20px 0;">
                                <el-image style="height:100%; width: 100%;" :src="item.url" :preview-src-list="images.map(i => i.url)" />
                                <div class="delete-img">
                                    <i class="el-icon-delete" @click="deleteimg(item.id)"></i>
                                </div>
                            </li>
                        </div>
                    </div>
                </el-form>
            </el-tab-pane>
            <!-- 修改日志 -->
            <el-tab-pane :label="`日志`" name="second">
                <el-table border stripe v-loading="loading" :data="historyData">
                    <el-table-column type="index" label="#" align="center" width="50"/>
                    <!-- 时间 -->
                    <el-table-column :label="`时间`" align="center"  prop="created_at" />
                    <!-- 修改人 -->
                    <el-table-column :label="`人员`" align="center"  prop="change_user" />
                    <!-- 修改内容 -->
                    <el-table-column :label="`明细`" align="center"  prop="change_log" />
                </el-table>
            </el-tab-pane>
            <!-- 附件 -->
            <el-tab-pane :label="`附件`" name="third">
                <!-- 上传文件 -->
                <el-button icon="el-icon-upload2" @click="openUpload('file')" size="mini" type="primary">上传</el-button>
                <el-table
                    class="mt10"
                    tripe
                    border
                    :data="instrumentForm.file_list"  
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        label="#"
                        align="center"
                        width="60">
                    </el-table-column>
                    <!-- 文件名 -->
                    <el-table-column
                        prop="name"
                        :label="`文件名`"
                        align="center">
                    </el-table-column>
                    <!-- 文件类型 -->
                    <el-table-column
                        prop="type"
                        :label="`类型`"
                        align="center">
                        <template slot-scope="scope">
                            {{fileTypes.filter(i => i.value === scope.row.type)[0].name}}
                        </template>
                    </el-table-column>
                    <!-- 操作 -->
                    <el-table-column
                        prop="address"
                        align="center"
                        :label="`操作`">
                        <template slot-scope="scope">
                            <el-button class="p0 fontsize20" type="text" @click.prevent="view(scope.row.url)"><i class="el-icon-download"></i></el-button>
                            <el-button class="p0 fontsize20" type="text" @click.prevent="deleteFile(scope.$index)"><i class="el-icon-delete"></i></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <div class="mt10">
            <!-- 保存 -->
            <el-button size="small" type="primary" @click="submitInstrument">保存</el-button>
            <!-- 取消 -->
            <el-button size="small" @click="back">取消</el-button>
        </div>
    </div>
    <PictureSelect ref="pictureSelect" @complete="getAvatar" />
    <UploadFile ref="uploadFile" @complete="getFile" />
  </div>
</template>

<script>
import PictureSelect from '@/components/common/PictureSelect/index.vue'
import UploadFile from '@/components/common/UploadFile.vue'
import { vendorOptions, instrumentList,instrumentEdit,instrumentTopLists, checkInstrumentUdi } from '@/api.js' 
export default {
    name:'instrumentEdit',
    components: {
        PictureSelect,UploadFile
    },
    data() {
        return {
            activeName:'first',
            instrumentForm:{
                use_limit: 0,
                udi_info: [],
                image:[],
                file_list:[],
            },
            udiNum: 0,
            udiMaxTimes: 0,
            images:[],
            fileList:[],
            loading:false,
            groupOptions:[],
            typeOptions:[],
            sortgroups:[],
            sorttypes:[],
            vendorsOptions:undefined,
            produceOptions:[],
            //修改日志
            historyData:[],
            //器械规格
            dynamicTags: [],
            inputVisible: false,
            inputValue: '',
            //上传照片
            show:false,
            dialogVisible:false,
            // 表单校验
            rules: {
                // 器械名称不能为空
                name:[
                    { 
                      required: true, 
                      message: `名称不能为空`, 
                      trigger: "blur" 
                    }
                ],
                standard_name:[
                // 标准名称不能为空
                    { required: true, 
                      message: `标准名称不能为空`, 
                      trigger: "blur" }
                ]
            },
            fileTypes: [],
            //器械分组
            instrumentGroup:[]
        }
    },
    created() {
        this.searchgroupOption();
        // this.searchVendors();
        this.pageId = Number(this.$route.params.id)
        if (this.pageId) {
            this.getDetail(this.pageId)
        }
        // this.searchinstrumenGroup()
        this.listenScan()
    },
    methods: {
        listenScan() {
        // 监听扫码
        this.$scan(document, {
            onScan: (code) => {
                if (code) {
                    this.checkCodeAndAdd(code)
                }
                }
            })
        },
        async checkCodeAndAdd(code) {
            const { id } = await this.$utils.getCode(code)
            if (id === 'td001') {
                const rfids = code.substring(1, code.length - 1).split('$').filter(i => !!i)

                this.batchAddUdi(rfids)
            }
        },
        async getDetail(id) {
            // 获取器械详情
            const url = instrumentEdit.replace('{id}', id)
            const res = await this.$request('get', url, {})
            if (res) {
                this.instrumentForm = res;
                this.historyData = res.change_log;
                this.instrumentForm.file_list = this.instrumentForm.file;
                this.$set(this.instrumentForm, "instrument_part_type", res.instrument_part_type_id)
                this.images = this.instrumentForm.image;
                // this.produceOptions.forEach((i) => {
                //    if(i.id != res.produce_vendor_id){
                //         this.instrumentForm.produce_vendor_id = ''
                //    }
                // })
                if(res.instrument_type == 0){
                    this.instrumentForm.instrument_type = ''
                }
                if(res.produce_vendor_id == 0){
                    this.instrumentForm.produce_vendor_id = ''
                }
                if(res.weight == 0){
                    this.instrumentForm.weight = ''
                }
                if(res.group == 0){
                    this.instrumentForm.group = ''
                }
                if(res.instrument_part_type == 0){
                    this.instrumentForm.instrument_part_type = ''
                }
                
            }
        },
        //查询厂家
        searchVendors(name){
            const url = vendorOptions
            const query = {
                name: name,
                type: 3,
            }
            this.$request('get', url, query).then(res=>{     
                this.produceOptions = res
            })
        },
        //查询器械类型、器械归属
        searchgroupOption(){
            return this.$utils.getDict([302,303,322]).then((res) => {
            if(res){
                this.sortgroups = res[302];
                this.sorttypes = res[303];
                this.fileTypes = res[322]
                }
            })
        },
        addUdi() {
            // 添加udi
            if (!this.instrumentForm.name) {
              // 请输入器械名
                this.$message.error(`请输入器械`)
                return
            }

            const length = this.udiNum
            const codes = this.instrumentForm.udi_info || []
            for (let i = 0; i < length; i++) {
                const item = {
                    name: `${this.instrumentForm.name}-${codes.length + 1}`,
                    max_times: this.udiMaxTimes
                }
                
                codes.push(item)
            }

            this.$set(this.instrumentForm, 'udi_info', codes)
        },
        checkUdi() {
            this.checkUdiRepeat()
            this.checkUdiBinded()
        },
        checkUdiRepeat() {
            // 检查列表重复
            let exist = false
            this.instrumentForm.udi_info.forEach(i => {
                this.$set(i, '_listRepeat', false)
                let times = 0
                this.instrumentForm.udi_info.forEach(j => {
                    if (i.udi === j.udi && !!i.udi) {
                        times += 1
                    }
                })

                if (times > 1) {
                    this.$set(i, '_listRepeat', true)
                    exist = true
                }
            })

            if (exist) {
                // 存在已绑定的udi，请处理后重新检查
                this.$message.error(`存在已绑定的udi，请处理后重新检查`)
            }
        },
        async checkUdiBinded() {
            // 检查数据重复（是否绑定到其他器械）
            const { id } = this.instrumentForm
            const udis = this.instrumentForm.udi_info.map(i => i.udi).filter(i => !!i)
            if (!udis.length) return

            const params = {
                instrument_id: id || 0,
                udi_arr: udis
            }
            const checkData = await this.$request('post', checkInstrumentUdi, params)
            if (checkData) {
                if (checkData.length) {
                  // 存在已绑定的udi，请处理后重新检查
                  this.$message.error(`存在已绑定的udi，请处理后重新检查`)
                }

                this.instrumentForm.udi_info.forEach(i => {
                    this.$set(i, '_repeatIntrument', null)
                    checkData.forEach(c => {
                        if (c.udi === i.udi) {
                            this.$set(i, '_repeatIntrument', c.instrument_id)
                        }
                    })
                })
            }
        },
        async batchAddUdi(batch) {
            // 批量绑定udi/rfid
            const toFillLength = this.instrumentForm.udi_info.filter(i => !i.udi).length
            let confirm = true
            if (toFillLength < batch.length) {
              // 可添加udi的位置不足，继续添加吗？
                confirm = await this.$utils.confirm({ msg: `可添加udi的位置不足，继续添加吗？` })
            }

            if (confirm) {
                let batchIndex = 0
                this.instrumentForm.udi_info.forEach(i => {
                    if (!i.udi) {
                        this.$set(i, 'udi', batch[batchIndex])
                        batchIndex += 1
                    }
                })

                this.$nextTick(() => {
                    this.checkUdiRepeat()
                    this.checkUdiBinded()
                })
            }
        },
        goInstrument(id) {
            const url = `${window.location.origin}${this.$utils.siteBase()}basic/instrument/edit/${id}`
            
            window.open(url, '_blank')
        },
        // 删除UDI
        deleteUDI(index) {
            this.instrumentForm.udi_info.splice(index, 1)

            this.checkUdiRepeat()
        },
        //器械分组
        searchinstrumenGroup(){
            const url = instrumentTopLists
            this.$request('get', url).then(res=>{
                this.instrumentGroup = res
            })
        },
        //器械规格型号
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(res => {
                if(res){
                    this.$refs.saveTagInput.$refs.input.focus();
                }
            });
        },
        //规格型号去重
        unique(arr) {
            if (!Array.isArray(arr)) {
                console.log('type error!')
                return
            }
            var array = [];
            for (var i = 0; i < arr.length; i++) {
                if (array .indexOf(arr[i]) === -1) {
                    array .push(arr[i])
                }
            }
            return array;
        },
        handleInputConfirm() {
            let inputValue = this.instrumentForm.specification;
            // this.$set(this.instrumentForm,'specification',inputValue);
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            let srr1 = this.unique(this.dynamicTags);
            if (this.dynamicTags.length != srr1.length) {
              // 规格型号不能重复
                this.$message.warning(`规格型号不能重复`);
            }
            this.dynamicTags = srr1;
            this.inputVisible = false;
            this.instrumentForm.specification = undefined;
        },
        //保存器械数据
        submitInstrument(){
            this.$refs["instrumentForm"].validate(valid => {
            if (valid) {
                const { udi_info } = this.instrumentForm
                const lackUdiInfo = udi_info.filter(i => !i.name || !i.udi).length
                
                if (lackUdiInfo) {
                  // 请完善UDI信息
                    this.$message.error(`请完善UDI信息`)
                    return
                }

                this.buttonLoading = true;
                if (this.instrumentForm.id != null) {
                    const url = instrumentEdit.replace('{id}', this.instrumentForm.id)
                    this.instrumentForm.image = this.images.map(i => i.id)
                    this.instrumentForm.file = this.instrumentForm.file_list.map(i => i.id)
                    this.$request('post', url, this.instrumentForm).then(res => {
                        if(res != null){
                          // 修改成功
                            this.$message.success(`修改成功`);
                            // this.$router.push(`/basic/instrument/index`)
                            this.getDetail(this.pageId)
                        }
                    }).finally(() => {
                        this.buttonLoading = false;
                    });
                }else {
                    const urlCreate = instrumentList
                    this.instrumentForm.image = this.images.map(i => i.id)
                    this.instrumentForm.file = this.instrumentForm.file_list.map(i => i.id)
                    this.instrumentForm.specifications = this.dynamicTags
                    this.$request('post', urlCreate, this.instrumentForm).then(res => {
                        if(res){
                          // 新增成功
                            this.$message.success(`新增成功`);
                            // this.$router.push(`/basic/instrument/index`);
                            this.$router.replace(`/basic/instrument/edit/${res}`)
                            this.pageId = Number(res)
                        }
                    }).finally(() => {
                        this.buttonLoading = false;
                    });
                }
            }
            });
        },
        //取消按钮
        back() {
            window.history.back();
        },
        getAvatar(imgs) {
            for (let i = 0; i < imgs.length; i++) {
                const item = {id:imgs[i].fileId,url:imgs[i].fileUrl}
                this.images = this.images.concat(item);
            }
        },
        deleteimg(id) {
            this.images.forEach((i, d) => {
                if (i.id === id) {
                this.images.splice(d, 1)
                }
            })
        },
        deleteFile(index) {
            this.instrumentForm.file_list.splice(index, 1)
        },
        getFile(file) {
            // 接收文件
            const files = this.instrumentForm.file_list || []
            files.push({
                id: file.fileId,
                url: file.fileUrl,
                name: file.name,
                type: file.type
            })
            this.$set(this.instrumentForm, 'file_list', files)
        },
        view(src) {
            // 预览图片
            window.open(src, '_blank')
        },
        uploadAvatar() {
            // 上传器械图片
            this.$refs.pictureSelect.show()
        },
        // uploadFile() {
        //     // 上传证书
        //     this.$refs.uploadFile.show()
        // },
        openUpload(type) {
            if (type === 'picture') {
                this.$refs.pictureSelect.show()
            } else if (type === 'file') {
                this.$refs.uploadFile.show(this.fileTypes)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.instrument_edit{
    h3{
        color: #767676;
    }
    .instrument_center{
        background-color: white;
        border-radius: 10px;
        padding: 10px;
    }
    .divBorder{
        border: 2px solid #f9f9f9;
        border-radius: 10px;
        padding-top: 15px;
    }
    .upload-photo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        li {
            height: 170px;
            position: relative;
            list-style-type:none;
            .delete-img {
                display: none;
            }
          &:hover {
                .delete-img {
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    bottom: 0;
                    background: rgba(59, 60, 61, 0.5);
                    z-index: 999;
                    cursor: pointer;
                    text-align: center;
                    i {
                        font-size: 24px;
                        color: white;
                    }
                }
            }
        }
    }
}
</style>